import ReactGA from "react-ga4";
import fillInTheBlankSound from "../utils/audio/fill-in-the-blanks.wav";
import config from "../config";
import i18n from "../i18n";
import UIfx from "uifx";
export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
export const capitalize = (text) =>
  text.charAt(0).toUpperCase() + text.slice(1);
export const isActive = (value) => window.location.pathname === value;
export const objToQuerystring = (obj) => {
  let queryString = "";
  if (obj && Object.keys(obj).length > 0) {
    Object.keys(obj).map((key) => {
      if (Array.isArray(obj[parseInt(key, 10)])) {
        queryString += `${key}=${obj[parseInt(key, 10)].toString()}&`;
      } else {
        queryString += `${key}=${obj[parseInt(key, 10)]}&`;
      }
      return null;
    });
    // remove last &
    queryString = queryString.slice(0, -1);
  }
  return queryString;
};

export const difficulties = ["all", "A1", "A2", "B1", "B2", "C1", "C2"];

export const convertToKey = (value) =>
  value ? value.toLowerCase().replace(/\s/gi, "_") : "Nothing to convert";
export const splitCourseSectionTopicId = (courseSectionTopicId) => {
  const idValues = courseSectionTopicId ? courseSectionTopicId.split("|") : [];
  return {
    courseId: idValues[0],
    sectionId: idValues[1],
    topicId: idValues[2],
  };
};

export const randomId = (min = 19999, max = 59998) => {
  const minA = Math.ceil(min);
  const maxA = Math.floor(max);
  return Math.floor(Math.random() * (maxA - minA + 1)) + minA;
};

const beepSound = new UIfx(fillInTheBlankSound, { volume: 0.3 });

export const highlightSpeechText = (
  textContainer,
  speechMarks,
  setTimeoutArray,
) => {
  if (textContainer) {
    const container = document.querySelector(textContainer);
    if (container) {
      const newTimeouts = [];
      const words = container.querySelectorAll("[data-text]");
      words.forEach((currentValue, currentIndex) => {
        if (
          currentValue &&
          currentValue.dataset &&
          currentValue.dataset.text &&
          currentValue.dataset.text.trim() !== "" &&
          speechMarks[currentIndex] &&
          speechMarks[currentIndex].time >= 0
        ) {
          currentValue.style.opacity = 0.4;
          const speechMark = speechMarks[currentIndex];
          let timer = setTimeout(() => {
            // could add function at end of setTimeout to remove from newTimeouts array by removing timer at first index,
            // so stopHighlightingSpeechText function doesn't clearTimeout on already cleared timer
            // play the audio for the blank as its being highlighed
            if (currentValue.dataset.text.includes("_____")) {
              beepSound.play();
            }
            currentValue.style.opacity = 1;
          }, speechMark.time);
          newTimeouts.push(timer);
        }
      });
      setTimeoutArray(newTimeouts);
    }
  }
};

export const stopHighlightingSpeechText = (textContainer, timeoutArray) => {
  if (timeoutArray.length > 0) {
    // prevent further highlighting of words
    for (let i = 0; i < timeoutArray.length; i += 1) {
      clearTimeout(timeoutArray[i]);
    }
  }
  if (textContainer) {
    // revert each word opacity
    const container = document.querySelector(textContainer);
    if (container) {
      const words = container.querySelectorAll("[data-text]");
      words.forEach((currentValue) => {
        if (
          currentValue &&
          currentValue.dataset &&
          currentValue.dataset.text &&
          currentValue.dataset.text.trim() !== ""
        ) {
          currentValue.style.opacity = 1;
        }
      });
    }
  }
};

export const getUsernameFromAuthData = (authData) => {
  if (
    authData.username &&
    authData.username.includes("@") &&
    !authData.username.startsWith("Wayside")
  ) {
    // username is email, return sub instead
    return authData?.attributes?.sub;
  } else {
    return authData.username;
  }
};

export const trackRecommendedEvent = (name, params) => {
  if (ReactGA.isInitialized && process.env.REACT_APP_STAGE === "prod") {
    ReactGA.event(name, params);
  }
};

// Example:
// trackRecommendedEvent('exception', {
//   description: payload.message,
//   fatal: false,
// });

export const trackEvent = (category, action, label) => {
  if (ReactGA.isInitialized && process.env.REACT_APP_STAGE === "prod") {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
};

export const trackPageView = (page) => {
  if (ReactGA.isInitialized && process.env.REACT_APP_STAGE === "prod") {
    setTimeout(() => {
      /*
        Recommendation for SPA
        https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
      */
      ReactGA.set({ page });
      ReactGA.send({ hitType: "pageview" });
    }, 250); // Timeout to avoid sending before the document title changes
  }
};

export const objToSearchString = (obj) => {
  if (!obj) {
    return "";
  }
  // Create a new object with only non-empty properties
  const filteredObj = Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

  // Then use this new object to create URLSearchParams
  return new URLSearchParams(filteredObj).toString();
};

export const searchStringToObj = (searchString) => {
  if (!searchString) {
    return {};
  }
  return Object.fromEntries(new URLSearchParams(searchString));
};

export const utf8ToB64 = (str) =>
  window.btoa(unescape(encodeURIComponent(str)));

export const localeToForLangMap = {
  en: "english",
  "en-US": "english",
  it: "italian",
  de: "german",
  ga: "irish",
  pt: "portuguese",
  fr: "french",
  es: "spanish",
};

// Best-effort default when neither Cognito nor a Dynamo record has a forLang
// (e.g. brand new user who hasn't visited Settings yet). Derived from the
// current UI locale rather than left blank, since forLang is a required field.
export const getDefaultForLang = () =>
  localeToForLangMap[i18n.language] || "english";

export const getForLangCharacters = (forLang) => {
  if (forLang && forLang !== "") {
    const characters = config.forLanguages[forLang.toLowerCase()].characters;
    if (characters.length > 0) {
      return characters;
    }
  }

  return config.forLanguages[getDefaultForLang()].characters;
};